<!-- LiveChatButton.vue (Bootstrap 5.3 적용판) -->
<template>
  <div id="chat-wrapper">
    <!-- 플로팅 상담 아이콘 (드래그 가능) -->
    <button ref="chatIconRef" type="button" class="btn btn-primary rounded-circle shadow-lg p-0 border-0 chat-fab z-3"
      :style="{
        width: iconSize + 'px',
        height: iconSize + 'px',
      }" :aria-label="isChatOpen ? '라이브 채팅 닫기' : '라이브 채팅 열기'" aria-controls="livechatOffcanvas" @mousedown="startDrag"
      @touchstart.prevent="startDrag" @click="handleClick">
      <img src="@/assets/resources/img/chat-icon.png" alt="" class="img-fluid rounded-circle" />
    </button>

    <!-- Bootstrap Offcanvas: 우측 슬라이드 채팅 패널 -->
    <div ref="offcanvasEl" id="livechatOffcanvas" class="offcanvas offcanvas-end" tabindex="-1"
      aria-labelledby="livechatLabel">
      <div class="offcanvas-header border-bottom">
        <span id="livechatLabel" class="offcanvas-title fw-semibold fs-5">라이브 상담</span>
        <button type="button" class="btn-close" aria-label="닫기" @click="hideChat"></button>
      </div>

      <div class="offcanvas-body p-0 d-flex flex-column">
        <!-- 기존 팝업 컴포넌트: 내부 레이아웃은 Bootstrap 유틸리티로 꾸며 주세요 -->
        <LiveChatPopup @close="hideChat" />
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * Bootstrap 5.3 + Vue 3 (Composition API)
 * - window.bootstrap 미사용
 * - Offcanvas 프로그램 방식 제어 (getOrCreateInstance)
 * - 라우트 변경 시 자동 닫기
 */
import { ref, watch, onMounted, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";
import LiveChatPopup from "@/components/popup/LiveChatPopup.vue";
import { logDebug } from "@/utils/logHelper";

// 지침: 번들 하나만 로드(bootstrap.bundle 또는 ESM). 여기선 ESM import 사용.
import { Offcanvas } from "bootstrap";

const route = useRoute();

const chatIconRef = ref(null);
const offcanvasEl = ref(null);
let offcanvasInst = null;

const isChatOpen = ref(false);
const iconSize = ref(52);

onMounted(() => {
  // Offcanvas 인스턴스 (프로그램 방식, opt-in)
  offcanvasInst = Offcanvas.getOrCreateInstance(offcanvasEl.value, {
    scroll: true,
    backdrop: true,
    keyboard: true,
  });

  // 전환 이벤트로 상태 싱크
  offcanvasEl.value.addEventListener("shown.bs.offcanvas", () => {
    isChatOpen.value = true;
    logDebug("Offcanvas shown");
  });
  offcanvasEl.value.addEventListener("hidden.bs.offcanvas", () => {
    isChatOpen.value = false;
    logDebug("Offcanvas hidden");
  });
});

onBeforeUnmount(() => {
  offcanvasInst?.dispose();
});

watch(
  () => route.fullPath,
  () => {
    hideChat();
    logDebug("Route changed. Chat offcanvas closed.");
  },
);

function handleClick() {
  offcanvasInst?.show();
}

function hideChat() {
  offcanvasInst?.hide();
}
</script>

<style scoped>
.chat-fab {
  cursor: grab;
}

.offcanvas {
  max-width: 700px;
  width: 100%;
}
</style>
